import { useState } from 'react';
import moment from 'moment';
import ReverificationOverviewDev from './ReverificationOverviewDev';
import CollegeOverviewDev from './CollegeOverviewDev';
import VendorOverView from './VendorOverView';
import DateRangeSelector, { DateRange } from '../../component/DateRangeSelector/DateRangeSelector';

export default function ReverificationDashboardDev() {
    const [dateRange, setDateRange] = useState<DateRange>({
        startDate: moment().startOf('day').toDate(),
        endDate: moment().endOf('day').toDate(),
    });

    return (
        <>
            <ReverificationOverviewDev />
            <CollegeOverviewDev />

            <div className="d-flex justify-content-end mt-4 mb-2">
                <DateRangeSelector value={dateRange} onChange={setDateRange} />
            </div>
            <VendorOverView dateRange={dateRange} />
        </>
    )
}